<template>
  <div>
    <div v-if="$vuetify.breakpoint.width > 800" class="section_exam-item">
      <div v-for="(item, index) in items" :key="index" class="exam-item">
        <div
          class="d-flex flex-column pointer"
          @click="goToSpecialExamId(item.name)"
        >
          <div class="text_exam">
            <h6>{{ item.faName }}</h6>
          </div>
          <div class="exam-image">
            <img :src="images[item.name]" alt="" />
          </div>
        </div>
      </div>
    </div>

    <v-carousel v-else style="height: 300px" hide-delimiters>
      <div v-if="$vuetify.breakpoint.width < 600">
        <v-carousel-item
          v-if="$vuetify.breakpoint.width < 600"
          class="section_exam-item"
          v-for="(item, index) in items"
          :key="index"
        >
          <div
            class="d-flex flex-column pointer"
            @click="goToSpecialExamId(item.name)"
          >
            <div class="text_exam">
              <h6>{{ item.faName }}</h6>
            </div>
            <div class="exam-image">
              <img :src="images[item.name]" alt="" />
            </div>
          </div>
        </v-carousel-item>
      </div>
      <div v-else>
        <v-carousel-item
          v-for="(item, index) in computedItems"
          class="section_exam-item"
          :key="index"
        >
          <div
            class="d-flex flex-column pointer"
            @click="goToSpecialExamId(item.items[0].name)"
          >
            <div class="text_exam">
              <h6>{{ item.items[0].faName }}</h6>
            </div>
            <div class="exam-image">
              <img :src="images[item.items[0].name]" alt="" />
            </div>
          </div>
          <div
            class="d-flex flex-column pointer"
            @click="goToSpecialExamId(item.items[1].name)"
          >
            <div class="text_exam">
              <h6>{{ item.items[1].faName }}</h6>
            </div>
            <div class="exam-image">
              <img :src="images[item.items[1].name]" alt="" />
            </div>
          </div>
        </v-carousel-item>
      </div>
    </v-carousel>
  </div>
</template>

<script>
import allMajors from "../../assets/images/allMajors.png";
import art from "../../assets/images/art.webp";
import foreignLanguages from "../../assets/images/foreignLanguages.png";
import humanities from "../../assets/images/humanities.webp";
import mathematic from "../../assets/images/mathematic.webp";
import science from "../../assets/images/science.webp";
import vocational from "../../assets/images/vocational.webp";
import vueCarousel from "vue-carousel";

export default {
  name: "publisherSlider",
  components: {
    vueCarousel,
  },
  props: {
    items: {},
  },
  data() {
    return {
      computedItems: [],
      images: {
        art,
        allMajors,
        foreignLanguages,
        humanities,
        mathematic,
        science,
        vocational,
      },
    };
  },
  methods: {
    goToSpecialExamId(item) {
      let link = "/store/entranceExam=true&entranceExamMajor=" + item;
      this.$router.push(link);
    },
    sliceItems() {
      for (let i = 0; i < this.items.length / 2; i++) {
        if (i == 0) {
          this.computedItems.push({
            items: [this.items[i], this.items[i + 1]],
          });
        } else {
          this.computedItems.push({
            items: [this.items[i * 2], this.items[i * 2 + 1]],
          });
        }
      }
    },
  },
  mounted() {
    this.sliceItems();
  },
};
</script>
<style lang="scss" scoped>
.section_exam-item {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  @media only screen and (max-width: 768px) {
    display: flex;
    justify-content: center;
    text-align: center;
  }
}
.exam-item {
  @media only screen and (max-width: 768px) {
    display: flex;
    justify-content: center;
    text-align: center;
  }
}
.exam-image {
  width: 230px;
  height: 200px;
  @media only screen and (max-width: 1366px) {
    width: 180px;
    height: 160px;
  }
  @media only screen and (max-width: 1024px) {
    width: 160px;
    height: 140px;
  }
  @media only screen and (max-width: 768px) {
    width: 200px;
    height: 180px;
  }
  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
}
.text_exam {
  padding: 10px;
  padding-bottom: 0 !important;
  h6 {
    font-size: 15px;
    font-weight: 600;
  }
}
.slider-items {
  & .v-slide-group__wrapper {
    .v-slide-group__content {
      border-bottom: none !important;
    }
  }
  & [class~="v-slide-group__next"] {
    min-width: 25px !important;
  }
  & [class~="v-slide-group__prev"] {
    min-width: 25px !important;
  }
}
.main-page {
  .products {
    // &.special-products {
    //   overflow-x: auto;
    //   overflow-y: hidden;
    //   scroll-behavior: smooth;
    //   .product-item {
    //     max-width: none;
    //   }
    //   &::-webkit-scrollbar {
    //     display: none;
    //   }
    // }

    .publish-item {
      width: 100%;
      height: 250px;
      background-color: #fff;
      border-radius: 12px;
      overflow: hidden;
      @media (max-width: 1024px) {
        width: 250px;
        justify-content: center;
      }
      @media (max-width: 375px) {
        width: 200px;
        justify-content: center;
      }
      .product-image {
        height: 250px;
        @media (max-width: 375px) {
          width: 100%;
          height: 100%;
        }
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
    // .publish-item {
    //   max-width: 250px;
    //   height: 250px;
    //   @media (max-width: 375px) {
    //     max-width: 200px;
    //     justify-content: center;
    //   }
    //   .product-image {
    //     width: 230px;
    //     height: 230px;
    //     @media (max-width: 375px) {
    //       width: 190px;
    //     }
    //     img {
    //       width: 100%;
    //       height: 100%;
    //       object-fit: contain;
    //     }
    //   }
    // }
  }
}

.slider {
  position: relative;
  @media only screen and (min-width: 1279px) {
    margin: 0 46px;
  }
  @media only screen and (max-width: 1279px) {
    margin: 0 10px;
  }
  &-button {
    position: absolute;
    transform: translateY(-30px);
    .v-btn {
      height: 50px !important;
      border-radius: 50px !important;
      background-color: #c6b9e4;
      i {
        color: #a076f9;
      }
    }
  }
  .slider-right-button {
    top: 50%;
    right: -60px;
  }
  .slider-left-button {
    top: 50%;
    left: -60px;
  }
}
.banner {
  overflow-x: hidden !important;
  width: 100% !important;
  height: auto !important;
  background-size: cover !important;
  position: center !important;
  @media screen and (max-width: 600px) {
    height: 150px !important;
    background-size: cover !important;
    position: center !important;
    width: 100% !important;
  }
}
</style>
